import { ANNUAL_COUPON, FIRST_MONTH_COUPON } from '@/utils/promoOffer/coupons';

import { messages } from './messages';

type BannerCopy = {
	title: (typeof messages)['firstMonthTitle'];
	cta: (typeof messages)['firstMonthCta'];
};

const COPY_BY_COUPON: Record<string, BannerCopy> = {
	[ANNUAL_COUPON]: { title: messages.annualTitle, cta: messages.annualCta },
	[FIRST_MONTH_COUPON]: { title: messages.firstMonthTitle, cta: messages.firstMonthCta },
};

export const getBannerCopy = (coupon: string | null): BannerCopy | undefined =>
	coupon ? COPY_BY_COUPON[coupon] : undefined;
